// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fI5T","content":"styles_content__1VPV0","tableWrap":"styles_tableWrap__AFrwN"};